import { Component, Input } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { ModalController } from '@ionic/angular';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
// import { TrackingService } from '@app/@shared/services/tracking.service';

@Component({
  selector: 'app-instructions',
  templateUrl: './instructions.component.html',
  styleUrl: './instructions.component.scss',
})
export class InstructionsComponent {
  @Input() gameType = '';
  @Input() type = '';
  htmlString: SafeHtml | undefined;
  instructionBD = '';

  constructor(
    private afs: AngularFirestore,
    private modalCtrl: ModalController,
    private sanitizer: DomSanitizer // private trackingS: TrackingService
  ) {
    //console.log(this.gameType);
    //console.log(this.type);
  }

  async ngOnInit() {
    const getInstructions = await this.getByProduct(this.type);
    this.instructionBD = getInstructions ? getInstructions.intrucctions : '';
    this.htmlString = this.sanitizer.bypassSecurityTrustHtml(this.instructionBD);
  }

  async getByProduct(product: string): Promise<any> {
    const collection = this.afs.collection('gamesHome').ref;

    const snap = await collection.where('product', '==', product).limit(1).get();

    if (!snap.empty) {
      const doc = snap.docs[0];
      const data = doc.data() as Record<string, any>; // asegúrate que data es un objeto
      return { ...data, id: doc.id };
    } else {
      return null;
    }
  }

  sendUtil(util: boolean) {
    const utilEvent = String(util);
    // this.trackingS.trackEvent(
    //   'utilty_instructions',
    //   {
    //     game_type: this.gameType,
    //     type: this.type,
    //     util: utilEvent,
    //   },
    //   false,
    //   false
    // );
  }

  close() {
    this.modalCtrl.dismiss();
  }
}
